'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import withAvailableWidth from '../../../_libs/react-with-available-width';
import {NavigationBreadcrumbView} from './NavigationBreadcrumbView';


// TODO: style links
export class BaseNavigationBreadcrumbComponent extends Component {
  static propTypes = {
    className: T.string,
    path: T.arrayOf(T.shape({
      id: T.string,
      label: T.string,
      to: T.string,
      toParams: T.object,
    })),
    availableWidth: T.number,
    windowWidth: T.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
      containerWidth: null,
    };

    this.handleClickEllipsis = this.handleClickEllipsis.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setEllipsisButtonRef = this.setEllipsisButtonRef.bind(this);
    this.setContainerRef = this.setContainerRef.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.availableWidth !== this.props.availableWidth) {
      this.setState({
        containerWidth: this.container.clientWidth,
      });
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, false);
    document.addEventListener('touchend', this.handleClickOutside, false);
    this.mounted = true;
  }

  componentWillUnmount() {
    if (this.mounted) {
      this.mounted = false;
      document.removeEventListener('click', this.handleClickOutside, false);
      document.removeEventListener('touchend', this.handleClickOutside, false);
    }
  }

  setEllipsisButtonRef(node) {
    this.ellipsisButtonRef = node;
  }

  setContainerRef(node) {
    this.container = node;
  }

  handleClickOutside(event) {
    if (this.ellipsisButtonRef && !this.ellipsisButtonRef.contains(event.target)) {
      this.setState({showDropdown: false});
    }
  }

  handleClickEllipsis(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      showDropdown: !this.state.showDropdown,
    });
  }

  render() {
    return (
      <div
        className="NavigationBreadcrumb__container"
        ref={this.setContainerRef}
      >
        <NavigationBreadcrumbView
          path={this.props.path}
          availableWidth={this.props.availableWidth}
          containerWidth={this.state.containerWidth}
          windowWidth={this.props.windowWidth}
          showDropdown={this.state.showDropdown}
          setEllipsisButtonRef={this.setEllipsisButtonRef}
          onClickEllipsis={this.handleClickEllipsis}
        />
      </div>
    );
  }
}

export const NavigationBreadcrumbComponent = withAvailableWidth(BaseNavigationBreadcrumbComponent, {
  wrapperClassName: 'NavigationBreadcrumb',
  usePropsClassName: true,
});

/**
 * @typedef {Object} NavigationBreadcrumbPath
 * @property {String} id
 * @property {String} label
 * @property {String} to
 * @property {Object} [toParams]
 */



// WEBPACK FOOTER //
// ./src/js/components/views/NavigationBreadcrumb/NavigationBreadcrumbComponent.js